export const initialState = { isChangePlanModalOpened: false, coupon: null };

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "OPEN_CHANGE_PLAN_MODAL":
      return { isChangePlanModalOpened: true, coupon: action.coupon };
    case "CLOSE_CHANGE_PLAN_MODAL":
      return { isChangePlanModalOpened: false };
    default:
      return state;
  }
};
export default reducer;
